import axios from 'axios';

const version = 'v1';
const basePath = 'shipment-label';

export async function getByShipment(shipmentReference) {
  return axios.request({
    url: `/${version}/${basePath}/shipment/${shipmentReference}`,
    method: 'get',
  });
}

export async function getContent(id) {
  return axios.request({
    url: `/${version}/${basePath}/content`,
    method: 'get',
    params: {
      id,
    },
  });
}

export async function confirmPrint(id) {
  return axios.request({
    url: `/${version}/${basePath}/print`,
    method: 'put',
    params: {
      id,
    },
  });
}

export async function confirmPrintShipment(shipmentReference) {
  return axios.request({
    url: `/${version}/${basePath}/shipment/${shipmentReference}/print`,
    method: 'put',
  });
}

export async function unlockLabel(id) {
  return axios.request({
    url: `/${version}/${basePath}/unlock`,
    method: 'post',
    params: {
      id,
    },
  });
}
